var Clusters = /** @class */ (function () {
    function Clusters() {
        this.GPSLat = 0;
        this.GPSLong = 0;
        this.ClusterType = "";
        this.Assessment = 0;
        this.AssessmentDate = "";
        this.SignClusterID = "";
    }
    return Clusters;
}());
export { Clusters };
var RoadClusters = /** @class */ (function () {
    function RoadClusters() {
        this.GPSLat = 0;
        this.GPSLong = 0;
        this.ClusterType = "";
        this.Assessment = 0;
        this.AssessmentDate = "";
        this.RoadClusterID = "";
        this.AssessmentClusterID = 0;
        this.Category = "";
    }
    return RoadClusters;
}());
export { RoadClusters };
var RoadClustersRaw = /** @class */ (function () {
    function RoadClustersRaw() {
        this.Lt = 0;
        this.Lg = 0;
        this.Ct = "";
        this.As = 0;
        this.Dt = "";
        this.CtID = "";
        this.ID = 0;
        this.CtType = "";
    }
    return RoadClustersRaw;
}());
export { RoadClustersRaw };
var ClusterType = /** @class */ (function () {
    function ClusterType() {
    }
    return ClusterType;
}());
export { ClusterType };
//# sourceMappingURL=Clusters.js.map